import { TTableColumn, TUseTableHooks } from '../../components/blocks/FnDataTable/types';
import React, { ReactElement } from 'react';
import { TBomEntry, TKsfEntry } from './redux/types';
import SubmissionStatus from './components/SubmissionStatus/index';
import FnColorCircle from '../../components/elements/FnColorCircle';

export const INITIAL_REQUEST = {
  accountId: '',
  filterItems: [],
  page: 1,
  pageLimit: 10,
  requestPage: '',
  sortItems: []
};

export const TABLE_COLUMNS_BOM: TTableColumn<TBomEntry>[] = [
  {
    Header: 'Submission status',
    accessor: 'status',
    style: {
      width: '120px'
    },
    Cell: ({ row }: TUseTableHooks<TBomEntry>): ReactElement => {
      const { original } = row;
      return <SubmissionStatus status={original.status} />;
    }
  },
  {
    Header: 'SKU',
    accessor: 'sku',
    style: {
      width: '160px'
    }
  },
  {
    Header: 'Blank Color',
    accessor: 'color',
    style: {
      width: '120px'
    },
    Cell: ({ row }: TUseTableHooks<TBomEntry>): ReactElement => {
      const { original } = row;
      return <FnColorCircle color={original.color} />;
    }
  },
  {
    Header: 'Size',
    accessor: 'size',
    style: {
      width: '60px'
    }
  },
  {
    Header: 'More Info',
    accessor: 'moreInfo',
    style: {
      width: '160px'
    },
    sticky: 'right'
  }
];

export const TABLE_COLUMNS_KSF: TTableColumn<TKsfEntry>[] = [
  {
    Header: 'Submission status',
    accessor: 'status',
    style: {
      width: '120px'
    },
    Cell: ({ row }: TUseTableHooks<TKsfEntry>): ReactElement => {
      const { original } = row;
      return <SubmissionStatus status={original.status} />;
    }
  },
  {
    Header: 'Directory',
    accessor: 'directory',
    style: {
      width: '120px'
    }
  },
  {
    Header: 'Panel',
    accessor: 'panel',
    style: {
      width: '120px'
    }
  },
  {
    Header: 'Blank Color',
    accessor: 'blankColor',
    style: {
      width: '120px'
    },
    Cell: ({ row }: TUseTableHooks<TKsfEntry>): ReactElement => {
      const { original } = row;
      return <FnColorCircle color={original.blankColor} />;
    }
  },
  {
    Header: 'Size Range',
    accessor: 'sizeRange',
    style: {
      width: '120px'
    }
  },
  {
    Header: 'MIM',
    accessor: 'mim',
    style: {
      width: '120px'
    },
    sticky: 'right'
  }
];
